import styles from './Story.module.css'; 
import { useEffect, useState } from "react";
import ReactMarkdown from 'react-markdown'

interface StoryProps {
  content: string;   // TODO: Import this?
  onLoaded: () => void;
}

function Story(props: StoryProps) {
  const [content, setContent] = useState("Loading...");

  useEffect(() => {
    setContent("Loading...")
    
    fetch(`story/${props.content}.md`)
      .then((res) => res.text())
      .then((text) => setContent(text))
      .then(() => props.onLoaded())
      .catch(() => setContent("Oh no, something went wrong!"));
  }, [props.content]);

  return (
    <div className={styles.Story}>
      <ReactMarkdown children={content} />
    </div>
  );
}

export default Story;
